import Watermarkjs from "@tencent/watermarkjs";
import { Message } from "element-ui";
import i18n from "@/i18n";

// 全局公共方法

// 注册keydown事件，处理ctrl + a默认全选
export function keyboardCtrlACancel() {
    window.addEventListener("keydown", function(event) {
        if (event.ctrlKey && event.keyCode === 65) {
            const nodeName = event.target.nodeName;
            const isInputNode = ["input", "textarea"].includes(nodeName.toLowerCase());
            let hasInputCls = false;
            for (const c of event.target.classList || []) {
                hasInputCls = c === "input";
                if (hasInputCls) {
                    break;
                }
            }
            if (isInputNode || hasInputCls) {
                return;
            }
            event.preventDefault();
            console.log("ctrl + a prevented");
        }
    });
}

// 添加水印方法
export function setWaterMark(name) {
    new Watermarkjs(name, {
        IGraphOptions: {
            font: "100 20px Arial",
            fillTextX: 10,
            fillTextY: 100,
            width: 210,
            height: 140,
            textAlign: "left",
            textBaseline: "hanging",
            color: "rgba(0,0,0,0.1)",
            textMaxLength: 12
        },
        opacity: 0.9,
        enableObserver: true
    });

    setWMMutation();
}

// 水印观察器
export function setWMMutation() {
    function getAttrs() {
        const wm = document.querySelector("w-m");
        return wm.getAttributeNames().map(attr => ({ name: attr, value: wm.getAttribute(attr) }));
    }

    function observing(observer) {
        const wm = document.querySelector("w-m");
        observer.observe(wm, {
            childList: true,
            attributes: true,
            subtree: true
        });
    }

    const observer = new MutationObserver(() => {
        observer.disconnect();
        const wm = document.querySelector("w-m");
        wm.getAttributeNames().forEach(name => wm.removeAttribute(name));
        wmAttrs.forEach(({ name, value }) => wm.setAttribute(name, value));
        observing(observer);
    });

    const wmAttrs = getAttrs();
    observing(observer);
}

// 注册copy和menu事件，处理复制场景
export function copyShowTips() {
    document.addEventListener("copy", event => {
        if (event.target.nodeName === "IMG") {
            return;
        }
        Message.error({ message: i18n.t("all.copyWarning"), iconClass: "el-icon-warning-outline", customClass: "copy-tip" });
    });
    document.addEventListener("contextmenu", event => {
        if (event.target.tagName !== "IMG") {
            return
        }
        event.preventDefault();
        const imgSrc = event.target.src;
        const copyImg = document.createElement("img");
        copyImg.src = imgSrc;
        document.body.appendChild(copyImg);
        const range = document.createRange();
        range.selectNode(copyImg);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        document.body.removeChild(copyImg);
        Message.error({ message: i18n.t("all.copyWarningPic"), iconClass: "el-icon-warning-outline", customClass: "copy-tip" });
    });
}

export function isTestEnv() {
    const currentUrl = window.location.hostname;
    const isTestEnv = currentUrl.indexOf("test") !== -1;
    return isTestEnv;
}